import {Injectable} from '@angular/core';
import {Graphql} from './graphql';
import {NotificationDto} from '../dto/notification-dto';
import {EmployeeNotificationOverviewDto} from '../dto/employee-notification-overview-dto';
import {
  markNotificationsAsRead,
  retrieveEmployeeNotificationOverview,
  retrieveNotificationsByUserId
} from '../graphql/notification.graphql';

@Injectable({
  providedIn: 'root',
})
export class Notification extends Graphql {

  public retrieveNotifications(page: number, size: number, fields: string[] = ['id']) {
    return this.query<NotificationDto[]>(retrieveNotificationsByUserId(fields), {
      page: page,
      size: size
    }, "retrieveNotificationsByUserId");
  }

  public markNotificationsAsRead() {
    return this.mutation<boolean>(markNotificationsAsRead(),{}, "markNotificationsAsRead");
  }

  public retrieveEmployeeNotificationOverview(employeeKeycloakIds: string[], fields: string[] = ['employeeKeycloakId', 'hasOpenAssessmentNotifications']) {
    return this.query<EmployeeNotificationOverviewDto[]>(retrieveEmployeeNotificationOverview(fields), {
      employeeKeycloakIds: employeeKeycloakIds
    }, "retrieveEmployeeNotificationOverview");
  }

}
